import React, { FC } from 'react'
import BannerLogo from '../assets/img/dt-expe_login.png'

export const Root: FC = () => {
  return (
    <div className="flex flex-col items-center"></div>
  )
}
